module.exports = __webpack_public_path__ + "static/media/icon_live_white.12c619d1.png";